import React, {FC, ReactNode} from 'react';

import {sanitizeHrefInput} from '../../../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {InputDialog} from '../../../../../libs/shared/ui/src/components/dialogs/inputDialog';

/*
 * Props.
 */

interface FormattingUrlDialogProps {
  title: ReactNode;
  url: string | undefined;
  onUrlChange: (arg: string | undefined) => void;
  onRequestClose: () => void;
  label?: ReactNode;
}

/*
 * Component.
 */

export const FormattingUrlDialog: FC<FormattingUrlDialogProps> = ({
  title,
  url,
  onUrlChange,
  onRequestClose,
  label,
}) => {
  const onValueSelect = (value: string) => {
    onUrlChange(sanitizeHrefInput(value) || undefined);
    onRequestClose();
  };

  return (
    <InputDialog
      title={title}
      label={label}
      initialValue={(url && sanitizeHrefInput(url)) || ''}
      onValueSelect={onValueSelect}
      onRequestClose={onRequestClose}
    />
  );
};
